import { useState, useEffect, Suspense } from "react";
import { Modal, Fade, Backdrop, Button, Chip } from "@material-ui/core";
import { Editor } from "@tinymce/tinymce-react";
import { LazyCustomDialog } from "../../";
import { makeStyles } from "@material-ui/core";
import { RichTextEditorModalProps } from "../../../../@types/components/richTextEditorModalProps.types";
import { DialogProps } from "../../../../@types/dialogProps.types";

import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

import "./richTextEditorModal.css";
// eslint-disable-next-line arrow-parens
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3)
	},
	actionIcon: {
		color: "#424242",
		marginTop: 5,
		marginRight: 5,
		fontSize: "1.1rem"
	}
}));

const RichTextEditorModal = ({
	openRichTextEditorModal,
	handleSave,
	handleRichTextEditorModalClose,
	richTextEditorProps
}: RichTextEditorModalProps) => {
	const classes = useStyles();
	const [tempContent, setTempContent] = useState<string>(richTextEditorProps && richTextEditorProps.initialValue);
	const [dialogProps, setDialogProps] = useState<DialogProps>({
		openDialog: false,
		title: "",
		content: "",
		actions: []
	});

	const handleClose = () => {
		setDialogProps(Object.assign({}, dialogProps, { openDialog: false }));
		handleRichTextEditorModalClose();
	};

	const _handleSave = async () => {
		const { type } = richTextEditorProps;
		await handleSave(type, tempContent);
	};
	const handleSaveAndClose = async () => {
		const { type } = richTextEditorProps;
		//await handleSave();
		await handleSave(type, tempContent);
		setTimeout(() => {
			handleRichTextEditorModalClose();
		}, 2000);
	};

	const handleCancel = () => {
		setDialogProps({
			openDialog: true,
			title: "Are you sure you want to Cancel?",
			content: "All your changes will be reverted to original",
			actions: [
				{
					label: "Go Back",
					callback: () => setDialogProps(Object.assign({}, dialogProps, { openDialog: false }))
				},
				{
					label: "Cancel",
					callback: () => handleClose()
				}
			]
		});
	};

	const handleEditor = (content: string, editor: any) => setTempContent(content);

	useEffect(() => {
		// console.log("richTextEditorProps");
		if (richTextEditorProps) {
			const { initialValue } = richTextEditorProps;
			setTempContent(initialValue);
		}
	}, [richTextEditorProps]);

	return (
		<div className="rich-text-editor-modal">
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={openRichTextEditorModal}
				//onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500
				}}
			>
				<Fade
					in={openRichTextEditorModal}
					style={{
						zIndex: 9999
					}}
				>
					<div className={classes.paper}>
						<div className="editor-header">
							<Chip
								label={richTextEditorProps && richTextEditorProps.type}
								style={{
									//backgroundColor: "#85CE36",
									color: "#424242",
									fontWeight: "bold",
									letterSpacing: 1
								}}
							/>
						</div>
						<div className="action-button-container">
							<Button
								onClick={_handleSave}
								style={{
									backgroundColor: "#85CE36",
									color: "#424242",
									paddingBottom: 2,
									paddingTop: 2,
									width: 80,
									marginRight: 20
								}}
							>
								<span>
									<SaveIcon className={classes.actionIcon} />
								</span>
								<span className="action-bttn-text">Save</span>
							</Button>
							<Button
								onClick={handleSaveAndClose}
								style={{
									backgroundColor: "#85CE36",
									color: "#424242",
									paddingBottom: 2,
									paddingTop: 2,
									width: 150,
									marginRight: 20
								}}
							>
								<span>
									<SaveIcon className={classes.actionIcon} />
								</span>
								<span className="action-bttn-text">Save and Close</span>
							</Button>
							<Button
								onClick={handleCancel}
								style={{
									backgroundColor: "#85CE36",
									color: "#424242",
									paddingBottom: 2,
									paddingTop: 2,
									width: 80
								}}
							>
								<span>
									<CancelIcon className={classes.actionIcon} />
								</span>
								<span className="action-bttn-text">Cancel</span>
							</Button>
						</div>
						<Editor
							initialValue={richTextEditorProps?.initialValue || "<p></p>"}
							init={{
								height: 500,
								menubar: false,
								plugins: [
									"advlist autolink lists link image charmap print preview anchor",
									"searchreplace visualblocks code fullscreen",
									"insertdatetime media table paste code help wordcount"
								],
								toolbar:
									"undo redo | formatselect | bold italic backcolor | \
                                alignleft aligncenter alignright alignjustify | \
                                bullist numlist outdent indent | removeformat | help"
							}}
							onEditorChange={handleEditor}
						/>
					</div>
				</Fade>
			</Modal>
			<Suspense fallback={<div />}>
				<LazyCustomDialog dialogProps={dialogProps} />
			</Suspense>
		</div>
	);
};

export default RichTextEditorModal;
